<template>
  <div class="menus-page">
    <div class="menus-hero">
      <div>
        <p class="hero-kicker mb-1">ویرایش منو</p>
        <h1 class="mb-0">{{ menu.name || '...' }}</h1>
        <div class="menus-hero-chips">
          <span v-if="menu.id" class="menus-hero-chip">#{{ menu.id }}</span>
          <span v-if="positionText" class="menus-hero-chip">{{ positionText }}</span>
          <span v-if="menu.status === 1" class="menus-hero-chip is-active">فعال</span>
        </div>
      </div>
      <div class="hero-side">
        <div class="hero-count">
          <strong>{{ totalItemsCount }}</strong>
          <span>آیتم</span>
        </div>
        <div class="hero-badge">
          <b-icon icon="diagram-3"></b-icon>
        </div>
      </div>
    </div>

    <div class="menus-toolbar">
      <div class="menus-toolbar-actions">
        <button type="button" class="menus-tool-btn is-primary" v-b-modal.create-menu-item>
          <b-icon icon="plus-lg"></b-icon>
          <span>افزودن آیتم</span>
        </button>
        <button type="button" class="menus-tool-btn" v-b-modal.editMenu @click="fillEditMenuObj">
          <b-icon icon="sliders"></b-icon>
          <span>ویرایش ویژگی های منو</span>
        </button>
        <button type="button" class="menus-tool-btn" @click="categoriesToMenu">
          <b-icon icon="diagram-2"></b-icon>
          <span>تبدیل دسته بندی به منو</span>
        </button>
      </div>
      <router-link class="menus-tool-btn" :to="{ name: 'MenuPanel' }">
        <b-icon icon="arrow-right"></b-icon>
        <span>پنل منوها</span>
      </router-link>
    </div>

    <b-modal id="editMenu" ref="editMenu" centered scrollable hide-header-close
             modal-class="menus-modal" @ok="onSubmit">
      <template #modal-header="{ cancel }">
        <menu-modal-header icon="sliders" title="ویرایش منو" subtitle="عنوان منو"
                           @close="cancel()"/>
      </template>

      <form @submit.stop.prevent="onSubmit">

        <form-group :validations="$v.editMenu.name">
          <div slot-scope="{ errors, invalid }" class="menus-modal-field">
            <label>عنوان منو</label>
            <b-form-input type="text" v-model="editMenu.name" placeholder="عنوان منو"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

      </form>

      <template #modal-footer="{ ok, cancel }">
        <div class="menus-modal-actions">
          <button type="button" class="menus-btn is-primary" @click="ok()">
            <b-icon icon="check2"></b-icon>
            <span>ویرایش</span>
          </button>
          <button type="button" class="menus-btn" @click="cancel()">انصراف</button>
        </div>
      </template>
    </b-modal>

    <div class="menus-section-title">
      <b-icon icon="list-nested"></b-icon>
      <span>آیتم ها</span>
      <span class="menus-chip">{{ totalItemsCount }}</span>
    </div>

    <div class="menus-list-panel">
      <div v-if="!rootItems.length" class="menus-empty">
        <b-icon icon="list-nested"></b-icon>
        <span>هیچ آیتمی برای این منو تعریف نشده است.</span>
        <button type="button" class="menus-empty-btn" v-b-modal.create-menu-item>افزودن اولین آیتم</button>
      </div>
      <div v-else class="menus-tree">
        <MenuItem v-for="item in rootItems" :key="item.id" :item="item"/>
      </div>
    </div>

    <b-modal id="create-menu-item" hide-footer centered scrollable hide-header-close modal-class="menus-modal">
      <template #modal-header="{ cancel }">
        <menu-modal-header icon="plus-square" title="افزودن آیتم" subtitle="آیتم جدید در این منو"
                           @close="cancel()"/>
      </template>
      <menu-item-form mode="create" @cancel="$bvModal.hide('create-menu-item')"/>
    </b-modal>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MenuItem from "../../components/dashboard/menu/MenuItem";
import FormGroup from "../../components/validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager from '../../components/validator/FormErrorsManager.vue'
import MenuItemForm from "@/plugin/components/dashboard/menu/MenuItemForm.vue";
import MenuModalHeader from "@/plugin/components/dashboard/menu/MenuModalHeader.vue";
import "@/plugin/components/dashboard/menu/menus-ui.css";

export default {
  name: "Menu",
  components: {MenuModalHeader, MenuItemForm, MenuItem, FormGroup, FormErrorsManager},
  data() {
    return {
      menuPositions: [
        {text: 'منو اصلی فروشگاه', value: 'store_nav'},
        {text: 'منو فوتر سایت', value: 'store_footer'},
        {text: 'منو اصلی وبلاگ', value: 'blog_nav'},
        {text: 'منو فوتر وبلاگ', value: 'blog_footer'}],

      menuID: this.$route.params.id,
      editMenu: {}
    };
  },
  validations: {
    editMenu: {
      name: {required},
    }
  },
  computed: {
    ...mapGetters({
      menu: "Menu/getMenu",
      items: "Menu/getMenuItems"
    }),
    rootItems() {
      return this.menu && Array.isArray(this.menu.children) ? this.menu.children : []
    },
    totalItemsCount() {
      const count = (list) => (Array.isArray(list) ? list : [])
          .reduce((total, item) => total + 1 + count(item.children), 0)
      return count(this.rootItems)
    },
    positionText() {
      const found = this.menuPositions.find(item => this.menu && item.value === this.menu.position)
      return found ? found.text : ''
    },
  },
  methods: {
    updateMenuFeature() {
      this.$store.dispatch("Menu/updateMenu", this.editMenu)
    },
    fillEditMenuObj() {
      this.editMenu = this.menu
      this.editMenu.menu_id = this.menu.id
      // background field is hidden; API still requires a hex color
      if (!/^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(String(this.editMenu.background || ''))) {
        this.editMenu.background = '#FFFFFF'
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.updateMenuFeature()
        this.$nextTick(() => {
          this.$bvModal.hide('editMenu')
        })
      }
    },
    categoriesToMenu() {
      this.$store.dispatch("Menu/categoriesToMenu", {id:this.menuID})
    }
  },
  mounted() {
    this.$store.dispatch("Menu/getMenu", this.menuID)
  }

}
</script>
